
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.353 12.543H21.5v-1.086H4.353l2.528-2.528a.543.543 0 00-.767-.768l-3.455 3.455a.543.543 0 000 .768l3.455 3.455a.542.542 0 10.767-.768l-2.528-2.528z","fill-rule":"nonzero"}})])
          )
        }
      }
    